import { camelCase } from "lodash";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { DisconnectButton, IntegrationConnectionHandler } from "../IntegrationComponents";
import { Actions as PAYMENT_INTEGRATION_ACTIONS } from "./store/paymentIntegrationActions";

// TODO replace logo
// import Logo from "./assets/fyorin-logo.svg"

const PaymentIntegrationSettings = ({
	integration,
	isComingSoon,
	logo,
	connected,
	userConnected,
	functionality,
	status,
	connect,
	verifyConnection,
	disconnect,
	getCompanies,
	getAccounts,
	updateField,
	save,
	linkOrganisation,
	integrationSettings,
}) => {
	const [expand, setExpand] = useState(false);

	// used to mark expanded so we fetch company and accounts data once
	useEffect(() => {
		if (!connected && expand) {
			setExpand(false);
		}
	}, [connected]);

	// TODO get information on whether this integration supports multi-company and multi-accounts to avoid these requests
	// fetches all companies linked with this payment integration
	// fetches all bank accounts linked with this integration
	useEffect(() => {
		if (expand && !integrationSettings?.companies) {
			getCompanies(integration);
		}
		if (expand && integrationSettings?.settings?.companyId) {
			getAccounts(integration);
		}
	}, [expand, integrationSettings?.settings?.companyId]);

	return (
		<div className="col-sm-12 integration-row">
			<div className="col-xs-3">
				<img
					src={logo}
					height="40px"
					alt={`${integration} logo`}
				/>
				<span style={{ paddingLeft: 20, fontSize: 16 }}>{integration}</span>
			</div>
			<div className="col-xs-9">
				<IntegrationConnectionHandler
					functionality={functionality}
					connected={connected}
					isComingSoon={isComingSoon}
					status={status}
					connect={connect}
					verifyConnection={verifyConnection}
					userConnected={userConnected}
					disconnect={disconnect}
					setExpand={() => setExpand(!expand)}
					expand={expand}
				/>
			</div>
			<div className="clearfix" />
			{expand && (
				<>
					<div className="px-6">
						<div className="col-xs-3 pl-0 mt-4"></div>
						<div className="col-xs-9 px-0 pt-3 flex justify-end items-start">
							<DisconnectButton
								connected={connected}
								disconnect={disconnect}
							/>
						</div>
					</div>
					<div className="col-sm-12">
						<div className="row">
							{integrationSettings?.companies && integrationSettings?.companies.length > 0 && (
								<div
									className="col-sm-6"
									style={{ marginTop: "15px" }}
								>
									<label>Company</label>

									<Select
										value={integrationSettings?.companies?.find(
											(c) => c.value == integrationSettings?.settings?.companyId,
										)}
										// isDisabled={disabled}
										onChange={(selectedOption) => {
											linkOrganisation(selectedOption.value);
										}}
										options={integrationSettings?.companies}
									/>
									<div className="clearfix" />
								</div>
							)}
							<div
								className="col-sm-6"
								style={{ marginTop: "15px" }}
							>
								<label>Bank Account</label>

								<Select
									value={integrationSettings?.accounts?.find(
										(a) => a.value == integrationSettings?.settings?.accountId,
									)}
									// isDisabled={disabled}
									onChange={(selectedOption) => {
										updateField("accountId", selectedOption.value);
									}}
									options={integrationSettings?.accounts}
								/>
								<div className="clearfix" />
							</div>
						</div>
						<div className="pull-right">
							<button
								className="btn btn-success"
								disabled={integrationSettings?.saving}
								onClick={(e) => {
									e.preventDefault();
									if (integrationSettings?.saving) return;
									save(integration);
								}}
							>
								{integrationSettings?.saving ? "Saving..." : "Save"}
							</button>
						</div>
					</div>
				</>
			)}
		</div>
	);

	// TODO add expandable options for selecting a Company and an Account
};

const mapStateToProps = (state, ownProps) => {
	const { integration } = ownProps;

	const settings = state?.integration?.payment?.[camelCase(integration)];
	const { functionality, logo, isComingSoon } = state?.integrationDetails?.payment?.[camelCase(integration)] || {};
	const userConnected = state.my?.integration?.payment?.[camelCase(integration)];

	const companyPayPeriods = state.payPeriods?.periods?.map((period) => {
		const paySchedule = state.company?.settings?.paySchedules?.find(
			(schedule) => schedule.id == period.paySchedule,
		);

		return {
			...period,
			name: `${paySchedule?.name} ${period.period} ${period.year}`,
		};
	});

	return {
		companyPayPeriods,
		connected: !!settings,
		functionality,
		logo,
		pollActionModal: settings?.pollActionModal,
		settings,
		currency: state?.company?.settings?.currency,
		status: settings?.status,
		onGoingPolls: settings?.onGoingPolls,
		isComingSoon,
		integrationSettings: settings,
		userConnected,
	};
};

const mapDispatchToProps = (dispatch, { integration }) => ({
	connect: (credentials) => dispatch(PAYMENT_INTEGRATION_ACTIONS.connectPaymentIntegration(integration, credentials)),
	verifyConnection: () => dispatch(PAYMENT_INTEGRATION_ACTIONS.verifyConnection(integration)),
	disconnect: () => dispatch(PAYMENT_INTEGRATION_ACTIONS.disconnectPaymentIntegration(integration)),
	getCompanies: () => dispatch(PAYMENT_INTEGRATION_ACTIONS.getCompanies(integration)),
	getAccounts: () => dispatch(PAYMENT_INTEGRATION_ACTIONS.getAccounts(integration)),
	save: () => dispatch(PAYMENT_INTEGRATION_ACTIONS.save(integration)),
	updateField: (field, value) => dispatch(PAYMENT_INTEGRATION_ACTIONS.updateField(integration, field, value)),
	linkOrganisation: (companyId) => dispatch(PAYMENT_INTEGRATION_ACTIONS.linkOrganisation(integration, companyId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentIntegrationSettings);
